import styled, { css } from 'styled-components';
import Typography from 'ggApp/shared/components/typography';
import ContentfulResolutionImage from 'ggApp/shared/components/resolutionImage/ContentfulResolutionImage';

export const Container = styled.div`
    padding-top: 60px;

    ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        padding: 60px 0;
    `};
`;

export const ImageContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${({ imgSize }) => `${imgSize}px`};

    ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        width: 100%;
        text-align: center;
        margin-bottom: 24px;
    `};
`;

export const CardContainer = styled.div`
    display: flex;
    padding-bottom: 60px;

    ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        display: block;
        padding-bottom: 24px;
    `};

    &:nth-child(odd) {
        ${ImageContainer} {
            margin-right: 16px;

            ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
                margin-right: 0;
            `};
        }
    }

    &:nth-child(even) {
        flex-direction: row-reverse; 

        ${ImageContainer} {
            margin-left: 16px;

            ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
                margin-left: 0;
            `};
        }
    }
`;

export const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const Image = styled(ContentfulResolutionImage)`
    img {
        object-position: top;
        max-width: ${({ imgSize }) => `${imgSize}px`};
        height: auto;

        ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
            max-width: 180px;
        `};
    }
`;

export const Title = styled.h2`
    ${(props) => css(props.theme.typography.Subheadline)};
    margin-bottom: 24px;

    ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-bottom: 18px;
    `}
`;

export const Description = styled(Typography)`
    ul {
        list-style: disc;
        padding-left: 24px;
    }

    li {
        ${({ theme }) => theme.typography.Paragraph};
        ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
            text-align: initial;
        `};
    }
`;
